export interface GetDefaultParameterOrderListRequest {
  configBranchCode: string
}

export function GetDefaultParameterOrderListRequestToJSON(
  value: GetDefaultParameterOrderListRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined
  }
}
